import * as CustomIcons from '../../assets';
import type { CSSProperties } from 'react';
import type * as AntdIcons from '@ant-design/icons';

export interface IconsProps {
  name: IconNames;
  className?: string;
  style?: CSSProperties;
  twoToneColor?: string;
  spin?: boolean;
  onClick?: () => void;
  rotate?: number;
  disabled?: boolean;
}

export type IconNames = AntdIconNames | CustomIconNames;
export type AntdIconNames = keyof typeof AntdIcons;
export type CustomIconNames = keyof typeof CustomIcons;

export function isCustomIcon(name: string): name is CustomIconNames {
  return Object.keys(CustomIcons).includes(name);
}
